import Vue from 'vue'
import App from './App.vue'
import router from "./router";
// 引入图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import ElementUI, { Message, Notification } from 'element-ui'; //导入element-ui
import 'element-ui/lib/theme-chalk/index.css'; //引入全部组件
import $ from 'jquery';
import i18n from './lang'
import store from './store'
import { codemirror } from "vue-codemirror";
import '@/assets/icons/index'
import echarts from "./utils/echarts"; // 导入echarts
import {handleTree,resetForm,parseTime,formatDateTime } from "@/utils/ys";
import { getDicts } from "@/api/dict/data";
import plugins from './plugins' // plugins
// 字典数据组件
import DictData from '@/components/DictData'
import '@/assets/css/style.css' // 全局样式，确保 TinyMCE 弹窗 z-index 样式生效
import '@/assets/css/system-page.css' // 系统配置类页面（用户/角色/菜单）的统一外观
import '@/assets/css/answer-ref.css' // 题干「引用答案」胶囊与选择器

// 全局方法挂载
Vue.prototype.handleTree = handleTree
Vue.prototype.parseTime = parseTime
Vue.prototype.formatDateTime = formatDateTime
Vue.prototype.getDicts = getDicts
Vue.prototype.resetForm = resetForm



Vue.use(ElementUI, {size: 'small', zIndex: 3000, i18n: (key, value) => i18n.t(key, value)});//设置全局配置对象
Vue.use(codemirror);
Vue.use(plugins);

// Allow click-to-dismiss for global tips/toasts to reduce operation blocking.
document.addEventListener('click', (event) => {
    const target = event && event.target
    if (!target || !target.closest) return
    if (target.closest('.el-message') || target.closest('.el-notification')) {
        Message.closeAll()
        Notification.closeAll()
    }
})

console.log("==>DictData",DictData)
console.log("Installing DictData...")
DictData.install()
console.log("✅ DictData installed!")
console.log("==>DictData.install()",DictData.install())


Vue.config.productionTip = false
window.$ = $;
Vue.prototype.$echarts = echarts;

Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999, // 设置图片预览组件的层级，确保能在其他组件之上
    },
})
new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
}).$mount('#app')
